// secondServer is a datasource 
// there used to be a first server, but it's gone now.

import { Component } from 'react';
import {putData, postData, deleteData, errorMessage, download, ssGetData, getDataCancel, getAPICancelToken} from './apiMethods'
import {httpSuccess} from '../Utils/status'

export default class SecondServer extends Component {
    constructor(props) {
      super(props);
  
      this.apiStatus = undefined;
      this.secondAuthToken = this.props.authToken;
      this.isAuthenticated = this.props.isAuthenticated;
      this.errorMsg = null;
      this.cancelToken = getAPICancelToken();
      this.host = this.props.host
    }

    cancel(message=null) {
        this.cancelToken.cancel(message);
    }

    async apiData(url) {
        this.apiStatus = 200;
        this.errorMsg = null
        try {
            const jsonResponse = await getDataCancel (this.secondAuthToken, url, this.cancelToken, this.host);
            this.errorLog(jsonResponse)
            return jsonResponse;
        }
        catch (e) {
            this.apiStatus = e?.response?.status;
            this.errorMsg = e?.response?.data?.data?.result?.message ?? e?.message
            return e
        }
    }

    async apiDataEx(url) {
        try {
            return await ssGetData(this.secondAuthToken, url);
        }
        catch(e) {
            this.errorMsg = e?.response.data.result.message;
            this.apiStatus = e?.response.status;
            return null;
        }
    }
 
    async apiProgress (url, callback) {
        return await download (this.secondAuthToken, url, callback);
    }

    async apiDataObj(url, hideAlert = false) {
        const resp = await this.apiData(url);
        return ( {jsonResponse: resp, errMsg: this.errorMsg, status: this.apiStatus} );
    }

    async apiSaveData(url, jsonData) {
        const jsonResponse = await putData (this.secondAuthToken, url, jsonData);
        this.errorLog(jsonResponse);
        return jsonResponse;
    }

    async apiInsertData(url, jsonData) {
        this.errorMsg = null
        const jsonResponse = await postData (this.secondAuthToken, url, jsonData);
        this.errorLog(jsonResponse);
        return jsonResponse;
    }
    async mockAPI (url, success) {  // for testing
        console.log ("mocking", url)
        this.errorMsg = success ? null : "Mock API error simulation"
        return success ? {status: 200} : {status: 500}
    }
    async mockProm (msg) {
        return Promise.reject(new Error(msg))
    }
    async apiDeleteData(url, jsonData, hideAlert) {
        const jsonResponse = await deleteData (this.secondAuthToken, url, jsonData, hideAlert);
        this.errorLog(jsonResponse);
        return jsonResponse;
    }

    throwOnError(apiResp, addInfo="") {
        const result = this.getErrorMsg() ?? errorMessage(apiResp)
        const msg = addInfo ? addInfo + ' '+ result : result
        if (result) throw new Error(msg)
        return apiResp
    }
    apiSuccess () {
        return this.apiStatus === undefined ? this.apiStatus : httpSuccess (this.apiStatus)
    }
    apiError () {
        return this.apiStatus === undefined ? this.apiStatus : !httpSuccess(this.apiStatus)
    }
    errorLog(serverJson) {
        if (this.logStatus(serverJson) > 399 || serverJson instanceof Error)
            this.errorMsg = errorMessage(serverJson) ?? serverJson?.toString();
        else
            this.errorMsg = null
    }
    
    getErrorMsg() {
        return this.errorMsg;
    }
    
    getStatus () {
        return this.apiStatus;
    }

    logStatus (respObj) {
        if (respObj instanceof Error) {
            this.apiStatus = respObj?.response?.status ?? 400
            return this.apiStatus;
        }
        this.apiStatus = respObj?.status ?? this.apiStatus;
        return this.apiStatus;
    }

    logState() {
        console.log ("auth", this.isAuthenticated, "token", this.secondAuthToken);
    }

    render() {
        return null;
    }
}
  